import window from 'window-or-global';

/**
 * Copied from https://stash.atlassian.com/projects/CONFCLOUD/repos/officeconnector
 * @see /officeconnector/Zen/src/main/resources/javascript/office-connector-macro-fields.js
 */
function overrideMacroDialog() {
	/**
	 * viewdoc, viewpdf, viewxls and viewppt should have the same behaviour for page/spacekey/date fields apart from
	 * attachment filter types, so we can use a common constructor.
	 */
	const ViewFileConfig = function (fileTypes) {
		this.fileTypes = fileTypes;
	};

	const isInTinyMceEditor = () => {
		return window.tinymce && !!window.tinymce.activeEditor;
	};

	const getCurrentTitle = () => {
		const contentType = window.AJS.Meta.get('content-type');

		if (contentType === 'page' || contentType === 'blogpost') {
			if (isInTinyMceEditor()) {
				return document.getElementById('content-title').value;
			} else {
				// TODO: We need a better way to get the page title when in the Fabric editor
				// Keying off the data-test-id is not a good idea, but it's the only viable
				// attribute I have too look for right now
				const titleElem = document.querySelector('[data-test-id=editor-title');
				return titleElem ? titleElem.value : '';
			}
		} else if (contentType === 'comment') {
			return window.AJS.Meta.get('page-title');
		}

		return '';
	};

	ViewFileConfig.prototype.beforeParamsSet = function (params) {
		// If the macro has no parameters set for the page, date or space set the page to the one
		// currently being edited. See beforeParamsRetrieved for the reverse.
		if (!params.page && !(params.date || params.space)) {
			// Empty string = Use current page
			params.page = '';
		}
		if (params.date) {
			// will be in format mm/dd/yyyy, should be yyyy/mm/dd
			const parts = params.date.split('/');
			params.page = ['', parts[2], parts[0], parts[1], params.page].join('/');
		}
		if (params.space) {
			params.page = `${params.space}:${params.page}`;
		}
		return params;
	};

	ViewFileConfig.prototype.beforeParamsRetrieved = function (params) {
		if (params.page) {
			const spacePageArr = params.page.split(':');
			if (spacePageArr.length > 1) {
				params.space = spacePageArr[0];
				params.page = spacePageArr[1];
			}
			const parts = params.page.split('/');
			if (parts.length > 1) {
				// will be in format yyyy/mm/dd/Page, should be mm/dd/yyyy
				params.date = [parts[2], parts[3], parts[1]].join('/');
				params.page = parts[4];
			}
			// If the page specified is the current page being edited, remove the page title parameter.
			// Even if a user entered it manually it is good to get rid of it as the macro parameters don't handle page renames
			// See beforeParamsSet for the reverse.
			if (params.page === getCurrentTitle()) {
				delete params.page;
			}
		}
		return params;
	};

	ViewFileConfig.prototype.fields = {
		attachment(param) {
			/**
			 *  Assumes value in form SPACEKEY:(/yyyy/mm/dd/)Title
			 */
			const parsePageLink = function (pageLink) {
				const o = {};

				const bits = pageLink.split(':', 2);
				o.spaceKey = (bits.length == 2 && bits[0]) || window.AJS.params.spaceKey;
				o.title = bits[bits.length - 1];

				if (o.title.indexOf('/') == 0) {
					// blogpost
					o.postingDay = o.title.substr(1, 10);
					o.title = o.title.substr(12);
				}

				// If the page title is the same as the page being edited, leave it blank and use the content Id.
				if (o.title === getCurrentTitle()) {
					o.title = '';
				}
				if (!o.title) {
					if (window.AJS.Meta.get('new-page')) {
						o.pageId = window.AJS.Meta.get('content-id');
					} else {
						o.pageId = window.AJS.Meta.get('page-id');
					}
				}
				return o;
			};

			const attachmentOptions = {
				fileTypes: this.fileTypes,
			};

			const field = window.AJS.MacroBrowser.ParameterFields['attachment'](param, attachmentOptions);

			field.dependencyUpdated = function (dependencyName, dependencyValue) {
				if (process.env.NODE_ENV !== 'production') {
					console.debug('Hightlight Current Node Plugin');
				}

				window.AJS.log(
					`attachment:dependencyUpdated called: ${dependencyName}, ${dependencyValue}`,
				);

				const req = parsePageLink(dependencyValue);
				this.getData(req);
			};
			return field;
		},

		/**
		 * Office Connector uses an unnecessary 'space' parameter which could be merged with the 'page' parameter as per
		 * other macros. In the Macro Browser we can get around this by just hiding the space param's div
		 */
		spacekey(param) {
			return window.AJS.MacroBrowser.ParameterFields['_hidden'](param, {});
		},

		/**
		 * Office Connector also uses an unnecessary 'date' parameter which could be merged with the 'page' parameter as per
		 * other macros. In the Macro Browser we can get around this by just hiding the date param's div
		 */
		date(param) {
			return window.AJS.MacroBrowser.ParameterFields['_hidden'](param, {});
		},

		'confluence-content': function (param) {
			const options = {
				// TODO - define the field with the dependency via the fallback. dT
				dependencies: ['name'],
			};

			return window.AJS.MacroBrowser.ParameterFields['confluence-content'](param, options);
		},
	};

	window.AJS.MacroBrowser.Macros.viewdoc = new ViewFileConfig(['doc', 'docx']);
	window.AJS.MacroBrowser.Macros.viewpdf = new ViewFileConfig(['pdf']);
	window.AJS.MacroBrowser.Macros.viewxls = new ViewFileConfig(['xls', 'xlsx']);
	window.AJS.MacroBrowser.Macros.viewppt = new ViewFileConfig(['ppt', 'pptx']);

	// Allow existing viewfile to redirect to correct alias for its filetype.
	window.AJS.MacroBrowser.Macros.viewfile = {
		updateSelectedMacro(macro) {
			const fileName = macro.params[''] || macro.params['name'];
			if (fileName) {
				const lastDot = fileName.lastIndexOf('.');
				if (lastDot > 0) {
					const ext = fileName.substring(lastDot + 1);
					if (ext) {
						ext == 'doc' && ext == 'docx' && (macro.name = 'viewdoc');
						ext == 'pdf' && (macro.name = 'viewpdf');
						ext == 'ppt' && ext == 'pptx' && (macro.name = 'viewppt');
						ext == 'xls' && ext == 'xlsx' && (macro.name = 'viewxls');
					}
				}
			}
		},
	};
}

export function officeConnector() {
	overrideMacroDialog();
}
